var map = {
	"./arrow-left-icon.svg": "4b87",
	"./arrow-right-icon.svg": "3f84",
	"./arrow-up-icon.svg": "7550",
	"./burger-icon.svg": "fdc5",
	"./cart-icon.svg": "18be",
	"./center-horizontal-icon.svg": "a0f7",
	"./center-vertical-icon.svg": "1644",
	"./centerd-aligned-icon.svg": "6334",
	"./check-icon.svg": "d9ff",
	"./choice-icon.svg": "5c70",
	"./close-icon.svg": "8a85",
	"./color-icon.svg": "d2e1",
	"./edit-icon.svg": "77ff",
	"./exclamationmark-icon.svg": "febf",
	"./eye.svg": "069a",
	"./fullscreen-collapse-icon.svg": "4d32",
	"./fullscreen-expand-icon.svg": "963c",
	"./info-icon.svg": "c943",
	"./left-aligned-icon.svg": "99a5",
	"./load-icon.svg": "351c",
	"./loading.svg": "56c7",
	"./motif-icon-white.svg": "8ff2",
	"./motif-icon.svg": "c94e",
	"./personalise-icon.svg": "0426",
	"./printingmode-icon.svg": "f018",
	"./product-icon-white.svg": "531f",
	"./product-icon.svg": "ae74",
	"./productinfo-icon.svg": "9466",
	"./resize-icon.svg": "0b63",
	"./right-aligned-icon.svg": "0c76",
	"./search-icon.svg": "5aef",
	"./share-icon.svg": "070c",
	"./text-icon-white.svg": "998d",
	"./text-icon.svg": "bd18",
	"./to-back.svg": "bfbb",
	"./to-front.svg": "5f6d",
	"./trash-icon.svg": "948f",
	"./upload-icon-white.svg": "4684",
	"./upload-icon.svg": "a975",
	"./zoom-out-icon.svg": "a996"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "abf3";